<template>
  <div v-if="!isOnlyDefaultNodePool" class="node-pool-name" aid="node-pool-name">
    <runai-ellipsis-text-with-tooltip :text="nodePoolName" anchor="bottom middle" />
  </div>
  <div v-else class="text-subtitle1 text-weight-medium" aid="entity-title">{{ entityTitle }}</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { RunaiEllipsisTextWithTooltip } from "@/components/common/runai-ellipsis-text-with-tooltip";
import { EQuotaEntity } from "@/models/resource.model";

export default defineComponent({
  components: {
    RunaiEllipsisTextWithTooltip,
  },
  inject: ["entity"],
  props: {
    isOnlyDefaultNodePool: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    nodePoolName: {
      type: String as PropType<string>,
      required: false,
    },
  },
  computed: {
    entityTitle(): string {
      return this.isProjectEntity ? "Project total" : "Department total";
    },
    isProjectEntity(): boolean {
      return this.entity === EQuotaEntity.project;
    },
  },
});
</script>
<style lang="scss" scoped>
.node-pool-name {
  font-size: 14px;
}
</style>
